export enum NOTIFICATION_DURATION {
	NORMAL = 5 * 1000,
}

export enum NOTIFICATION_TYPE {
	SUCCESS = 'success',
	ERROR = 'error',
	INFO = 'info',
	WARNING = 'warning',
}

export const NOTIFICATION_COUNT_VIEW = 5

export interface NotifyMessageCreatorOptions {
	data?: string[]
	options?: { type: NOTIFICATION_TYPE }
}

export const defaultOptions = {
	data: [],
	options: {
		type: NOTIFICATION_TYPE.SUCCESS,
	},
}
